import type { TableCellProps } from '@mui/material';
import { Checkbox, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import type { FC } from 'react';
import type { OrdersTableHeadProps } from './OrdersTable.types';

export const OrdersTableHead: FC<OrdersTableHeadProps> = ({
  headCells,
  selectedCount,
  rowCount,
  onSelectAllClick,
  isCheckboxDisabled,
  isLoading
}) => {
  const tableCellSx: TableCellProps['sx'] = {
    width: 200,
    px: { xs: 1, lg: 2 },
    py: { xs: 2, lg: 1 },
    borderBottom: '1px solid',
    borderColor: 'divider',
    bgcolor: 'background.paper'
  };

  return (
    <TableHead data-testid="orders-table-head">
      <TableRow>
        <TableCell sx={tableCellSx}>
          <Checkbox
            size="medium"
            data-testid="orders-table-select-all-checkbox"
            indeterminate={selectedCount > 0 && selectedCount < rowCount}
            checked={rowCount > 0 && selectedCount === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all orders' }}
            disabled={isCheckboxDisabled}
            sx={{
              opacity: isCheckboxDisabled ? 0.5 : 1
            }}
          />
        </TableCell>

        {headCells.map(
          (headCell) =>
            headCell.visible !== false && (
              <TableCell
                key={headCell.id}
                align="left"
                sx={({ palette }) => ({
                  ...tableCellSx,
                  ...(headCell.id === 'status' && !isLoading
                    ? {
                        position: 'sticky',
                        right: 0,
                        zIndex: 2,
                        '&:before': {
                          xs: {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            bottom: 0,
                            left: 0,
                            width: '1px',
                            backgroundColor: palette.divider
                          },
                          lg: {
                            content: 'none'
                          }
                        }
                      }
                    : {})
                })}
                role="columnheader"
              >
                <Typography component="span" variant="caption" whiteSpace="nowrap">
                  {headCell.label}
                </Typography>
              </TableCell>
            )
        )}
      </TableRow>
    </TableHead>
  );
};
